// extracted by mini-css-extract-plugin
export var auto = "_2d-1";
export var spinner = "_2d-0";